module.exports = __webpack_public_path__ + "static/media/dry_non_sensitive.c7a81885.png";